// Monkey Ride 3D - Cross-Platform Input Manager

export class InputManager {
  constructor() {
    this.actions = {
      moveLeft: false,
      moveRight: false,
      jump: false,
      slide: false,
      pause: false,
    };
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchStartTime = 0;
    this.swipeThreshold = 50;
    this.callbacks = {};
    this._boundKeyDown = this._onKeyDown?.bind(this);
    this._boundKeyUp = this._onKeyUp?.bind(this);
    this._boundTouchStart = this._onTouchStart?.bind(this);
    this._boundTouchEnd = this._onTouchEnd?.bind(this);
    this._boundGamepad = this._pollGamepad?.bind(this);
    this._gamepadInterval = null;
  }

  on(action, callback) {
    this.callbacks[action] = callback;
  }

  _emit(action) {
    if (this.callbacks?.[action]) this.callbacks?.[action]();
  }

  init(canvas) {
    window.addEventListener('keydown', this._boundKeyDown);
    window.addEventListener('keyup', this._boundKeyUp);
    if (canvas) {
      canvas?.addEventListener('touchstart', this._boundTouchStart, { passive: false });
      canvas?.addEventListener('touchend', this._boundTouchEnd, { passive: false });
    }
    this._gamepadInterval = setInterval(this._boundGamepad, 50);
  }

  destroy() {
    window.removeEventListener('keydown', this._boundKeyDown);
    window.removeEventListener('keyup', this._boundKeyUp);
    if (this._gamepadInterval) clearInterval(this._gamepadInterval);
  }

  _onKeyDown(e) {
    switch (e?.code) {
      case 'ArrowLeft': case 'KeyA': this._emit('moveLeft'); break;
      case 'ArrowRight': case 'KeyD': this._emit('moveRight'); break;
      case 'Space': case 'ArrowUp': case 'KeyW':
        e?.preventDefault();
        this._emit('jump');
        break;
      case 'ArrowDown': case 'KeyS': this._emit('slide'); break;
      case 'KeyP': case 'Escape': this._emit('pause'); break;
    }
  }

  _onKeyUp(e) {}

  _onTouchStart(e) {
    e?.preventDefault();
    const touch = e?.touches?.[0];
    this.touchStartX = touch?.clientX;
    this.touchStartY = touch?.clientY;
    this.touchStartTime = Date.now();
  }

  _onTouchEnd(e) {
    e?.preventDefault();
    const touch = e?.changedTouches?.[0];
    const dx = touch?.clientX - this.touchStartX;
    const dy = touch?.clientY - this.touchStartY;
    const dt = Date.now() - this.touchStartTime;
    const absDx = Math.abs(dx);
    const absDy = Math.abs(dy);

    if (dt < 300 && (absDx > this.swipeThreshold || absDy > this.swipeThreshold)) {
      if (absDx > absDy) {
        if (dx < 0) this._emit('moveLeft');
        else this._emit('moveRight');
      } else {
        if (dy < 0) this._emit('jump');
        else this._emit('slide');
      }
    }
  }

  _pollGamepad() {
    const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
    for (const gp of gamepads) {
      if (!gp) continue;
      const axisX = gp?.axes?.[0];
      if (axisX < -0.5) this._emit('moveLeft');
      else if (axisX > 0.5) this._emit('moveRight');
      if (gp?.buttons?.[0]?.pressed) this._emit('jump');
      if (gp?.buttons?.[1]?.pressed) this._emit('slide');
      if (gp?.buttons?.[9]?.pressed) this._emit('pause');
    }
  }

  // Mobile button triggers
  triggerLeft() { this._emit('moveLeft'); }
  triggerRight() { this._emit('moveRight'); }
  triggerJump() { this._emit('jump'); }
  triggerSlide() { this._emit('slide'); }
}

export default InputManager;
